import { getApiBaseUrl } from '../utils/apiConfig';

const ACCESS_GATE_TOKEN_KEY = 'accessGateToken';

export const getStoredAccessGateToken = (): string | null => {
  try {
    const token = localStorage.getItem(ACCESS_GATE_TOKEN_KEY);
    if (!token || token === 'null' || token === 'undefined') {
      return null;
    }
    return token.trim();
  } catch {
    return null;
  }
};

export const setStoredAccessGateToken = (token: string): void => {
  localStorage.setItem(ACCESS_GATE_TOKEN_KEY, token);
};

export const clearStoredAccessGateToken = (): void => {
  localStorage.removeItem(ACCESS_GATE_TOKEN_KEY);
};

export const fetchAccessGateStatus = async (): Promise<{ enabled: boolean }> => {
  const response = await fetch(`${getApiBaseUrl()}/api/access-gate/status`);
  if (!response.ok) {
    throw new Error('Failed to fetch access gate status');
  }
  return response.json();
};

export const verifyAccessGatePassword = async (password: string): Promise<{ success: boolean; token?: string; message?: string }> => {
  const response = await fetch(`${getApiBaseUrl()}/api/access-gate/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });

  const data = await response.json();
  if (!response.ok) {
    return { success: false, message: data.message || 'Invalid access code' };
  }

  return data;
};

export const checkAccessGateToken = async (token: string): Promise<{ valid: boolean }> => {
  const response = await fetch(`${getApiBaseUrl()}/api/access-gate/check`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Access-Gate-Token': token,
    },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    return { valid: false };
  }

  return response.json();
};
